import { PageHead } from "@/components/utils";
import { FadeUp } from "@/components/Reveal";
import { FAQS } from "@/lib/data";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { IDS } from "@/lib/testIds";

export default function FAQ() {
  return (
    <>
      <PageHead
        title="FAQ — Good Looks Unisex Salon, Mansa"
        description="Answers to common questions about services, bookings, bridal chapters and cancellations at Good Looks Salon."
      />
      <section className="bg-[#F3EAD9] pt-40 pb-24 md:pb-40">
        <div className="max-w-[1600px] mx-auto px-6 md:px-10">
          <FadeUp>
            <p className="eyebrow text-[#C89B3C] mb-6">— Frequently asked</p>
            <h1 className="font-display text-5xl md:text-8xl leading-[0.95] max-w-5xl">
              Answers, before<br /><span className="italic">you book.</span>
            </h1>
          </FadeUp>

          <FadeUp delay={0.1}>
            <div className="mt-14 max-w-4xl">
              <Accordion type="single" collapsible data-testid={IDS.faqAccordion}>
                {FAQS.map((f, i) => (
                  <AccordionItem
                    key={i}
                    value={`item-${i}`}
                    className="border-b border-black/10"
                  >
                    <AccordionTrigger className="text-left font-display text-lg md:text-2xl py-6 hover:no-underline">
                      <span className="flex items-baseline gap-4">
                        <span className="text-[#C89B3C] text-sm">
                          {String(i + 1).padStart(2, "0")}
                        </span>
                        <span>{f.q}</span>
                      </span>
                    </AccordionTrigger>
                    <AccordionContent className="text-black/65 leading-relaxed max-w-3xl pb-6 text-[15px]">
                      {f.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          </FadeUp>
        </div>
      </section>
    </>
  );
}
